module.exports = __webpack_public_path__ + "8ac278414a43c0c26309e0759c31c561.svg";